import { ParamEvent } from "../../../poly/ParamEvent";
import { Poly } from "../../../Poly";
export class ParamErrorState {
  constructor(param) {
    this.param = param;
  }
  set(message) {
    if (this._message != message) {
      this._message = message;
      if (this._message) {
        Poly.warn(this.param.path(), this._message);
      }
      this.param.emitController.emit(ParamEvent.ERROR_UPDATED);
    }
  }
  message() {
    return this._message;
  }
  clear() {
    this.set(void 0);
  }
  active() {
    return this._message != null;
  }
}
